module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-row', {
    staticClass: "container"
  }, [_c('el-col', {
    staticClass: "main",
    attrs: {
      "span": 24
    }
  }, [_c('aside', {
    class: _vm.collapsed ? 'menu-collapsed' : 'menu-expanded'
  }, [(!_vm.collapsed) ? _c('div', {
    staticClass: "all-title"
  }, [_c('div', {
    staticStyle: {
      "text-align": "center",
      "font-size": "18px",
      "font-weight": "550"
    }
  }, [_vm._v("运营管理平台")])]) : _vm._e(), _vm._v(" "), (_vm.collapsed) ? _c('div', {
    staticClass: "simple-title"
  }, [_vm._v("\n\t\t\t\t\tXZ\n\t\t\t\t")]) : _vm._e(), _vm._v(" "), (!_vm.collapsed) ? _c('el-menu', {
    staticClass: "el-menu-vertical-demo",
    attrs: {
      "default-active": _vm.$route.path,
      "unique-opened": "",
      "router": "",
      "background-color": "#285ccd"
    }
  }, [_vm._l((_vm.$router.options.routes), function(item, index) {
    return [(!item.hidden) ? _c('div', {
      key: index,
      staticClass: "menu-all-list"
    }, [(!item.leaf) ? _c('el-submenu', {
      staticClass: "menu-parent-list",
      attrs: {
        "index": index + ''
      }
    }, [_c('template', {
      slot: "title"
    }, [_c('div', {
      staticClass: "menu-parent"
    }, [_c('i', {
      class: item.iconCls
    }), _vm._v(_vm._s(item.name) + "\n\t\t\t\t\t\t\t\t\t")])]), _vm._v(" "), _vm._l((item.children), function(child) {
      return ((!child.hidden && !child.isAdmin) || (!child.hidden && child.isAdmin && _vm.isAdmin)) ? _c('el-menu-item', {
        key: child.path,
        staticClass: "menu-list menu-child-list",
        attrs: {
          "index": child.path
        }
      }, [_c('div', [_vm._v(_vm._s(child.name))])]) : _vm._e()
    })], 2) : _vm._e(), _vm._v(" "), (item.leaf && item.children.length > 0) ? _c('el-menu-item', {
      staticClass: "menu-list",
      attrs: {
        "index": item.children[0].path
      }
    }, [_c('i', {
      class: item.iconCls
    }), _vm._v(_vm._s(item.children[0].name) + "\n\t\t\t\t\t\t\t")]) : _vm._e()], 1) : _vm._e()]
  })], 2) : _vm._e(), _vm._v(" "), (_vm.collapsed) ? _c('ul', {
    ref: "menuCollapsed",
    staticClass: "el-menu collapsed small-menu-body"
  }, _vm._l((_vm.$router.options.routes), function(item, index) {
    return _c('li', {
      key: index,
      staticClass: "el-submenu item"
    }, [(!item.hidden) ? _c('div', [(!item.leaf) ? [_c('div', {
      staticClass: "small-menu-list",
      staticStyle: {
        "padding-left": "20px"
      },
      on: {
        "mouseover": function($event) {
          return _vm.showMenu(index, true)
        },
        "mouseout": function($event) {
          return _vm.showMenu(index, false)
        }
      }
    }, [_c('i', {
      class: item.iconCls
    })]), _vm._v(" "), _c('ul', {
      staticClass: "el-menu submenu",
      class: 'submenu-hook-' + index,
      on: {
        "mouseover": function($event) {
          return _vm.showMenu(index, true)
        },
        "mouseout": function($event) {
          return _vm.showMenu(index, false)
        }
      }
    }, _vm._l((item.children), function(child) {
      return ((!child.hidden && !child.isAdmin) || (!child.hidden && child.isAdmin && _vm.isAdmin)) ? _c('li', {
        key: child.path,
        staticClass: "el-menu-item small-menu-list-child",
        class: _vm.$route.path == child.path ? 'is-active' : '',
        staticStyle: {
          "padding-left": "40px"
        },
        on: {
          "click": function($event) {
            return _vm.$router.push(child.path)
          }
        }
      }, [_c('div', [_vm._v(_vm._s(child.name))])]) : _vm._e()
    }), 0)] : [_c('li', [_c('div', {
      staticClass: "small-menu-list",
      class: _vm.$route.path == item.children[0].path ? 'is-active' : '',
      staticStyle: {
        "padding-left": "20px",
        "height": "56px",
        "line-height": "56px",
        "padding": "0 20px"
      },
      on: {
        "click": function($event) {
          return _vm.$router.push(item.children[0].path)
        }
      }
    }, [_c('i', {
      class: item.iconCls
    })])])]], 2) : _vm._e()])
  }), 0) : _vm._e()], 1), _vm._v(" "), _c('section', {
    staticClass: "content-container"
  }, [_c('el-col', {
    staticClass: "header",
    attrs: {
      "span": 24
    }
  }, [_c('el-col', {
    attrs: {
      "xs": 2,
      "sm": 2,
      "md": 2,
      "lg": 2
    }
  }, [_c('div', {
    staticClass: "tools",
    staticStyle: {
      "margin-bottom": "64px"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.collapse.apply(null, arguments)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-align-justify",
    staticStyle: {
      "vertical-align": "middle",
      "color": "#353f4f"
    }
  })])]), _vm._v(" "), _c('el-col', {
    staticClass: "breadcrumb-container",
    attrs: {
      "xs": 16,
      "sm": 16,
      "md": 16,
      "lg": 16
    }
  }, [_c('strong', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.$route.name))])]), _vm._v(" "), _c('el-col', {
    staticClass: "userinfo",
    attrs: {
      "xs": 6,
      "sm": 6,
      "md": 6,
      "lg": 6
    }
  }, [_c('el-dropdown', {
    attrs: {
      "trigger": "hover"
    }
  }, [_c('span', {
    staticClass: "el-dropdown-link userinfo-inner"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/user2.png")
    }
  }), _vm._v("\n\t\t\t\t\t\t\t\t" + _vm._s(_vm.sysUserName) + "\n\t\t\t\t\t\t\t")]), _vm._v(" "), _c('el-dropdown-menu', {
    attrs: {
      "slot": "dropdown"
    },
    slot: "dropdown"
  }, [_c('router-link', {
    staticClass: "inlineBlock",
    staticStyle: {
      "text-decoration": "none",
      "color": "black"
    },
    attrs: {
      "to": "/"
    }
  }, [_c('el-dropdown-item', [_vm._v("\n\t\t\t\t\t\t\t\t\t\t首页\n\t\t\t\t\t\t\t\t\t")])], 1), _vm._v(" "), _c('el-dropdown-item', {
    attrs: {
      "divided": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.logout.apply(null, arguments)
      }
    }
  }, [_vm._v("退出登录")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "grid-content bg-purple-light"
  }, [_c('el-col', {
    staticClass: "content-wrapper",
    attrs: {
      "span": 24
    }
  }, [_c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [_c('router-view')], 1)], 1)], 1)], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a033eeda"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Home.vue
// module id = 1192
// module chunks = 2